/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {LiveFishTransactionPatch} from '../bioplanModels';
// @ts-ignore
import type {LiveFishTransactionPost} from '../bioplanModels';
// @ts-ignore
import type {LiveFishTransactionPut} from '../bioplanModels';
// @ts-ignore
import type {LiveFishTransactionResponse} from '../bioplanModels';
/**
 * PlanningLiveFishTransactionApi - axios parameter creator
 * @export
 */
export const PlanningLiveFishTransactionApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all live fish transaction for a plan
     * @param {string} planId
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsGet: async (
      planId: string,
      cageId?: string,
      siteId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('liveFishTransactionsGet', 'planId', planId);
      const localVarPath = `/liveFishTransactions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (cageId !== undefined) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create live fish transaction for a cage
     * @param {LiveFishTransactionPost} liveFishTransactionPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsPost: async (
      liveFishTransactionPost: LiveFishTransactionPost,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'liveFishTransactionPost' is not null or undefined
      assertParamExists('liveFishTransactionsPost', 'liveFishTransactionPost', liveFishTransactionPost);
      const localVarPath = `/liveFishTransactions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        liveFishTransactionPost,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete transaction by its identifier
     * @param {string} transactionId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsTransactionIdDelete: async (
      transactionId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('liveFishTransactionsTransactionIdDelete', 'transactionId', transactionId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('liveFishTransactionsTransactionIdDelete', 'planId', planId);
      const localVarPath = `/liveFishTransactions/{transactionId}`.replace(
        `{${'transactionId'}}`,
        encodeURIComponent(String(transactionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get live fish transaction by its identifier
     * @param {string} transactionId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsTransactionIdGet: async (
      transactionId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('liveFishTransactionsTransactionIdGet', 'transactionId', transactionId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('liveFishTransactionsTransactionIdGet', 'planId', planId);
      const localVarPath = `/liveFishTransactions/{transactionId}`.replace(
        `{${'transactionId'}}`,
        encodeURIComponent(String(transactionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Patch transaction by ID
     * @param {string} transactionId
     * @param {LiveFishTransactionPatch} liveFishTransactionPatch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsTransactionIdPatch: async (
      transactionId: string,
      liveFishTransactionPatch: LiveFishTransactionPatch,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('liveFishTransactionsTransactionIdPatch', 'transactionId', transactionId);
      // verify required parameter 'liveFishTransactionPatch' is not null or undefined
      assertParamExists('liveFishTransactionsTransactionIdPatch', 'liveFishTransactionPatch', liveFishTransactionPatch);
      const localVarPath = `/liveFishTransactions/{transactionId}`.replace(
        `{${'transactionId'}}`,
        encodeURIComponent(String(transactionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        liveFishTransactionPatch,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update transaction by ID
     * @param {string} transactionId
     * @param {LiveFishTransactionPut} liveFishTransactionPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsTransactionIdPut: async (
      transactionId: string,
      liveFishTransactionPut: LiveFishTransactionPut,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('liveFishTransactionsTransactionIdPut', 'transactionId', transactionId);
      // verify required parameter 'liveFishTransactionPut' is not null or undefined
      assertParamExists('liveFishTransactionsTransactionIdPut', 'liveFishTransactionPut', liveFishTransactionPut);
      const localVarPath = `/liveFishTransactions/{transactionId}`.replace(
        `{${'transactionId'}}`,
        encodeURIComponent(String(transactionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        liveFishTransactionPut,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningLiveFishTransactionApi - functional programming interface
 * @export
 */
export const PlanningLiveFishTransactionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningLiveFishTransactionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get all live fish transaction for a plan
     * @param {string} planId
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liveFishTransactionsGet(
      planId: string,
      cageId?: string,
      siteId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LiveFishTransactionResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liveFishTransactionsGet(
        planId,
        cageId,
        siteId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningLiveFishTransactionApi.liveFishTransactionsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create live fish transaction for a cage
     * @param {LiveFishTransactionPost} liveFishTransactionPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liveFishTransactionsPost(
      liveFishTransactionPost: LiveFishTransactionPost,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveFishTransactionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liveFishTransactionsPost(
        liveFishTransactionPost,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningLiveFishTransactionApi.liveFishTransactionsPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete transaction by its identifier
     * @param {string} transactionId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liveFishTransactionsTransactionIdDelete(
      transactionId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liveFishTransactionsTransactionIdDelete(
        transactionId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningLiveFishTransactionApi.liveFishTransactionsTransactionIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get live fish transaction by its identifier
     * @param {string} transactionId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liveFishTransactionsTransactionIdGet(
      transactionId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveFishTransactionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liveFishTransactionsTransactionIdGet(
        transactionId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningLiveFishTransactionApi.liveFishTransactionsTransactionIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Patch transaction by ID
     * @param {string} transactionId
     * @param {LiveFishTransactionPatch} liveFishTransactionPatch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liveFishTransactionsTransactionIdPatch(
      transactionId: string,
      liveFishTransactionPatch: LiveFishTransactionPatch,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveFishTransactionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liveFishTransactionsTransactionIdPatch(
        transactionId,
        liveFishTransactionPatch,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningLiveFishTransactionApi.liveFishTransactionsTransactionIdPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update transaction by ID
     * @param {string} transactionId
     * @param {LiveFishTransactionPut} liveFishTransactionPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liveFishTransactionsTransactionIdPut(
      transactionId: string,
      liveFishTransactionPut: LiveFishTransactionPut,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveFishTransactionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liveFishTransactionsTransactionIdPut(
        transactionId,
        liveFishTransactionPut,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningLiveFishTransactionApi.liveFishTransactionsTransactionIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningLiveFishTransactionApi - factory interface
 * @export
 */
export const PlanningLiveFishTransactionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningLiveFishTransactionApiFp(configuration);
  return {
    /**
     *
     * @summary Get all live fish transaction for a plan
     * @param {PlanningLiveFishTransactionApiLiveFishTransactionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsGet(
      requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<LiveFishTransactionResponse>> {
      return localVarFp
        .liveFishTransactionsGet(requestParameters.planId, requestParameters.cageId, requestParameters.siteId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create live fish transaction for a cage
     * @param {PlanningLiveFishTransactionApiLiveFishTransactionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsPost(
      requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LiveFishTransactionResponse> {
      return localVarFp
        .liveFishTransactionsPost(requestParameters.liveFishTransactionPost, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete transaction by its identifier
     * @param {PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsTransactionIdDelete(
      requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .liveFishTransactionsTransactionIdDelete(requestParameters.transactionId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get live fish transaction by its identifier
     * @param {PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsTransactionIdGet(
      requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LiveFishTransactionResponse> {
      return localVarFp
        .liveFishTransactionsTransactionIdGet(requestParameters.transactionId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Patch transaction by ID
     * @param {PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsTransactionIdPatch(
      requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LiveFishTransactionResponse> {
      return localVarFp
        .liveFishTransactionsTransactionIdPatch(
          requestParameters.transactionId,
          requestParameters.liveFishTransactionPatch,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update transaction by ID
     * @param {PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liveFishTransactionsTransactionIdPut(
      requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LiveFishTransactionResponse> {
      return localVarFp
        .liveFishTransactionsTransactionIdPut(
          requestParameters.transactionId,
          requestParameters.liveFishTransactionPut,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for liveFishTransactionsGet operation in PlanningLiveFishTransactionApi.
 * @export
 * @interface PlanningLiveFishTransactionApiLiveFishTransactionsGetRequest
 */
export interface PlanningLiveFishTransactionApiLiveFishTransactionsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsGet
   */
  readonly cageId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsGet
   */
  readonly siteId?: string;
}

/**
 * Request parameters for liveFishTransactionsPost operation in PlanningLiveFishTransactionApi.
 * @export
 * @interface PlanningLiveFishTransactionApiLiveFishTransactionsPostRequest
 */
export interface PlanningLiveFishTransactionApiLiveFishTransactionsPostRequest {
  /**
   *
   * @type {LiveFishTransactionPost}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsPost
   */
  readonly liveFishTransactionPost: LiveFishTransactionPost;
}

/**
 * Request parameters for liveFishTransactionsTransactionIdDelete operation in PlanningLiveFishTransactionApi.
 * @export
 * @interface PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdDeleteRequest
 */
export interface PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdDelete
   */
  readonly transactionId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for liveFishTransactionsTransactionIdGet operation in PlanningLiveFishTransactionApi.
 * @export
 * @interface PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdGetRequest
 */
export interface PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdGet
   */
  readonly transactionId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for liveFishTransactionsTransactionIdPatch operation in PlanningLiveFishTransactionApi.
 * @export
 * @interface PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPatchRequest
 */
export interface PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPatchRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPatch
   */
  readonly transactionId: string;

  /**
   *
   * @type {LiveFishTransactionPatch}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPatch
   */
  readonly liveFishTransactionPatch: LiveFishTransactionPatch;
}

/**
 * Request parameters for liveFishTransactionsTransactionIdPut operation in PlanningLiveFishTransactionApi.
 * @export
 * @interface PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPutRequest
 */
export interface PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPut
   */
  readonly transactionId: string;

  /**
   *
   * @type {LiveFishTransactionPut}
   * @memberof PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPut
   */
  readonly liveFishTransactionPut: LiveFishTransactionPut;
}

/**
 * PlanningLiveFishTransactionApi - object-oriented interface
 * @export
 * @class PlanningLiveFishTransactionApi
 * @extends {BaseAPI}
 */
export class PlanningLiveFishTransactionApi extends BaseAPI {
  /**
   *
   * @summary Get all live fish transaction for a plan
   * @param {PlanningLiveFishTransactionApiLiveFishTransactionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningLiveFishTransactionApi
   */
  public liveFishTransactionsGet(
    requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningLiveFishTransactionApiFp(this.configuration)
      .liveFishTransactionsGet(requestParameters.planId, requestParameters.cageId, requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create live fish transaction for a cage
   * @param {PlanningLiveFishTransactionApiLiveFishTransactionsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningLiveFishTransactionApi
   */
  public liveFishTransactionsPost(
    requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningLiveFishTransactionApiFp(this.configuration)
      .liveFishTransactionsPost(requestParameters.liveFishTransactionPost, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete transaction by its identifier
   * @param {PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningLiveFishTransactionApi
   */
  public liveFishTransactionsTransactionIdDelete(
    requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningLiveFishTransactionApiFp(this.configuration)
      .liveFishTransactionsTransactionIdDelete(requestParameters.transactionId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get live fish transaction by its identifier
   * @param {PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningLiveFishTransactionApi
   */
  public liveFishTransactionsTransactionIdGet(
    requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningLiveFishTransactionApiFp(this.configuration)
      .liveFishTransactionsTransactionIdGet(requestParameters.transactionId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Patch transaction by ID
   * @param {PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningLiveFishTransactionApi
   */
  public liveFishTransactionsTransactionIdPatch(
    requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningLiveFishTransactionApiFp(this.configuration)
      .liveFishTransactionsTransactionIdPatch(
        requestParameters.transactionId,
        requestParameters.liveFishTransactionPatch,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update transaction by ID
   * @param {PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningLiveFishTransactionApi
   */
  public liveFishTransactionsTransactionIdPut(
    requestParameters: PlanningLiveFishTransactionApiLiveFishTransactionsTransactionIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningLiveFishTransactionApiFp(this.configuration)
      .liveFishTransactionsTransactionIdPut(
        requestParameters.transactionId,
        requestParameters.liveFishTransactionPut,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
